import React, { useState, useEffect } from "react";
import { Empty, AutoComplete } from "antd";
import Utils from "../../../../utility/Utils";
import SIFilter from "../SiFilter";
import { useReportsStore } from "../../ReportsStore";
import { useSearchParams } from "react-router-dom";
const { Option } = AutoComplete;

const Gatewise = () => {
  const [snData, setSNData] = useState([]);

  const [gatewayData, setGatewayData] = useState([]);
  const [siDetails, setSIDetails] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const {
    gatewiseSerialNo,
    setGatewiseSerialNo,
    gatewiseFirstRender,
    setGatewiseFirstRender,
    tab,
  } = useReportsStore();
  const fetchData = async () => {
    const sn = await SIFilter.getGatewayWiseReport();
    setSNData(sn);
  };

  const fetchData2 = async (gatewiseSerialNo) => {
    if (gatewiseFirstRender) {
      let serialNo = searchParams.get("serialNumber");
      if (serialNo?.length > 0) {
        setGatewiseSerialNo();
      }
      setGatewiseFirstRender(false);
    }
    const [gdata, sid] = await Promise.all([
      SIFilter.getGatewaysbySNReport(gatewiseSerialNo),
      SIFilter.getGatewayWiseSNReport(gatewiseSerialNo),
    ]);
    setGatewayData(gdata);
    setSIDetails(sid);
  };

  const handleOptionSelect = (value) => {
    setGatewiseSerialNo(value);
    fetchData2(value);
  };
  const updateQueryParams = () => {
    setSearchParams({
      tab: tab,
      serialNumber: gatewiseSerialNo,
    });
  };
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (gatewiseSerialNo) {
      fetchData2(gatewiseSerialNo);
    }
  }, [gatewiseSerialNo]);

  useEffect(() => {
    if (!gatewiseFirstRender) {
      updateQueryParams();
    }
  }, [gatewiseSerialNo]);

  return (
    <>
      <div className="search-filter mb-3">
        <AutoComplete
          className="col-12 col-sm-6 col-lg-3"
          placeholder="Search by SerialNumber"
          value={gatewiseSerialNo}
          onChange={(value) => {
            setGatewiseSerialNo(value);
          }}
          onSearch={fetchData}
          onSelect={handleOptionSelect}
        >
          {snData.map((option) => (
            <Option key={option} value={`${option}`}>
              {`${option}`}
            </Option>
          ))}
        </AutoComplete>
      </div>

      {gatewiseSerialNo ? (
        gatewayData.length ? (
          gatewayData.map((item, index) => (
            <>
              <div className="info-container border rounded-3 bg-light mb-4">
                <div className="card-heading m-2">Gateway Details</div>
                <div className="info-container border-none rounded-3 bg-white p-3">
                  <div className="d-flex flex-md-row flex-column border-none  ">
                    <div className="col-sm d-flex justify-content-center w-100 p-3">
                      <div className="w-50">
                        <b>Serial Number</b>
                      </div>
                      <div className="w-50">{item.serialnumbersearch}</div>
                    </div>
                    <div className="col-sm d-flex justify-content-center w-100 p-3">
                      <div className="w-50">
                        <b>Manufacturer</b>s
                      </div>
                      <div className="w-50">{item.manufacturer}</div>
                    </div>
                  </div>
                  <div className="d-flex flex-md-row flex-column border-none ">
                    <div className="col-sm d-flex justify-content-center w-100 p-3">
                      <div className="w-50">
                        <b>Secure ID</b>
                      </div>
                      <div className="w-50">{item.secureid}</div>
                    </div>
                    <div className="col-sm d-flex justify-content-center w-100 p-3">
                      <div className="w-50">
                        <b>FW Model</b>
                      </div>
                      <div className="w-50">{item.currentfwmodel}</div>
                    </div>
                  </div>
                  <div className="d-flex flex-md-row flex-column border-none">
                    <div className="col-sm d-flex justify-content-center w-100 p-3">
                      <div className="w-50">
                        <b>Name</b>
                      </div>
                      <div className="w-50">{item.name}</div>
                    </div>
                    <div className="col-sm d-flex justify-content-center w-100 p-3">
                      <div className="w-50">
                        <b>FW Version</b>
                      </div>
                      <div className="w-50">{item.currentfwversion}</div>
                    </div>
                  </div>
                  <div className="d-flex flex-md-row flex-column border-none">
                    <div className="col-sm d-flex justify-content-center w-100 p-3">
                      <div className="w-50">
                        <b>Model</b>
                      </div>
                      <div className="w-50">{item.model}</div>
                    </div>
                    <div className="col-sm d-flex justify-content-center w-100 p-3">
                      <div className="w-50">
                        <b>Created</b>
                      </div>
                      <div className="w-50">
                        {item.created ? Utils.istTime(item.created) : "NA"}
                      </div>
                    </div>
                  </div>
                  <div className="d-flex flex-md-row flex-column border-none">
                    <div className="col-sm d-flex justify-content-center w-100 p-3">
                      <div className="w-50">
                        <b>Floors/Rooms</b>
                      </div>
                      <div className="w-50">
                        {item.jhgateways_floor_count[0]
                          ? item.jhgateways_floor_count[0].floorcount
                          : 0}
                        /
                        {item.jhgateways_room_count[0]
                          ? item.jhgateways_room_count[0].roomcount
                          : 0}
                      </div>
                    </div>
                    <div className="col-sm d-flex justify-content-center w-100 p-3">
                      <div className="w-50">
                        <b>Status</b>
                      </div>
                      <div className="w-50">{item.connectionstatus}</div>
                    </div>
                  </div>
                  <div className="d-flex flex-md-row flex-column border-none">
                    <div className="col-sm d-flex justify-content-center w-100 p-3">
                      <div className="w-50">
                        <b>Client Services</b>
                      </div>
                      <div className="w-50">NA</div>
                    </div>
                    <div className="col-sm d-flex justify-content-center w-100 p-3">
                      <div className="w-50">
                        <b></b>
                      </div>
                      <div className="w-50"></div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ))
        ) : (
          <div className="info-container border-none rounded-3">
            <p>Gateway Not Found!</p>
          </div>
        )
      ) : (
        ""
      )}

      {siDetails ? (
        siDetails.map((item, index) => (
          <>
            <div className="info-container border rounded-3 bg-light mb-4">
              <div className="card-heading m-2">SI Details</div>
              <div className="info-container border-none rounded-3 bg-white p-3">
                <div className="d-flex flex-md-row flex-column border-none  ">
                  <div className="col-sm d-flex justify-content-center w-100 p-3">
                    <div className="w-50">
                      <b>SI Name</b>
                    </div>
                    <div className="w-50">
                      {item.si_details.firstname} {item.si_details.lastname}
                    </div>
                  </div>
                  <div className="col-sm d-flex justify-content-center w-100 p-3">
                    <div className="w-50">
                      <b>SI Contact</b>
                    </div>
                    <div className="w-50">
                      {item.si_contact_details[0].contact}
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-md-row flex-column border-none ">
                  <div className="col-sm d-flex justify-content-center w-100 p-3">
                    <div className="w-50">
                      <b>Installation Time</b>
                    </div>
                    <div className="w-50">
                      {Utils.istTime(item.start_time)} -
                      {Utils.istTime(item.end_time)}
                    </div>
                  </div>
                  <div className="col-sm d-flex justify-content-center w-100 p-3">
                    <div className="w-50">
                      <b>Installation Duration</b>
                    </div>
                    <div className="w-50">
                      {Math.floor(item.total_hours * 100) / 100} hours
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ))
      ) : (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      )}
    </>
  );
};
export default Gatewise;
